import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const Main5SectionWrap = styled.div`
  display: block;
  height: 1440px;
  width: 100%;
  margin: 0 auto;
  max-width: 2560px;
  ${customMedia.lessThan('tablet')`
    height: 1246px;
`}
`

const Main5SectionContent = styled.div<{ bgImgSrc: string }>`
  width: 100%;
  max-width: 2560px;
  height: 720px;
  margin: 0 auto;
  display: block;
  border: none;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url(${(props) => props.bgImgSrc});
  background-size: cover;
  ${customMedia.lessThan('tablet')`
    height: 623px;
    margin-bottom: -2px;
    
`}
  ${customMedia.lessThan('tablet_cut_line')`
    background-position: 65% 50%;
    `}
`
const Main5SectionItem = styled.div`
  text-align: right;
  width: 100%;
  //height: 623px;
  max-width: 1363px;
  color: ${COLOR.white};
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  > img {
    margin-top: 80px;
    display: flex;
    width: 403.986px;
    flex-shrink: 0;
  }

  > div {
    padding-top: 502px;

    > h3 {
      font-family: NanumSquareNeoExtraBold, sans-serif;
      margin: 0;
      font-size: 60px;
      line-height: 66px;
    }

    > p {
      margin: 24px 0 0 0;
      font-family: NotoSansRegular, sans-serif;
      font-size: 20px;
      line-height: 29px;
    }
  }

  ${customMedia.lessThan('tablet')`
    height: 623px;
    float: none;
    text-align: center;
    max-width: unset;
    min-width: unset;
    margin:0;
     >img{
        display: none;
     }
    >div{   
      margin: 0 auto;
      padding:0;
    >h3{
     margin:0;
     padding: 87px 0 10px 0;
     font-size: 24px;
     line-height: 27px;
    }
    >p{
     margin:0;
     padding: 0 16px;
     font-size: 14px;
     line-height: 20px;
     }
    }
`}
`
export { Main5SectionContent, Main5SectionItem, Main5SectionWrap }
